module.exports = __webpack_public_path__ + "static/media/avatar_profile.ee5689cb.jpg";